import { render, staticRenderFns } from "./TopSubjectSituation.vue?vue&type=template&id=6d2f7574&scoped=true&lang=pug&"
import script from "./TopSubjectSituation.vue?vue&type=script&lang=ts&"
export * from "./TopSubjectSituation.vue?vue&type=script&lang=ts&"
import style0 from "./TopSubjectSituation.vue?vue&type=style&index=0&id=6d2f7574&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2f7574",
  null
  
)

export default component.exports